import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import styles from "./input.module.css";

const RadioButtons = (props) => {
	const { items, question, field, hasError, errorMessage, extraInfo } = props;

	return (
		<div className={styles.inner_form_label}>
			<p>{question}</p>
			<small>{extraInfo}</small>
			<RadioGroup
				{...field}
				style={{ display: "block", width: "100%", marginTop: "24px" }}
			>
				{items.map((item) => {
					const optionId = item?.option_id
						? item.option_id
						: items[1].option_id - 1;
					return (
						<FormControlLabel
							key={optionId}
							value={optionId}
							control={<Radio />}
							label={item.option_text}
							className={styles.inner_radio_check}
							style={{
								outline:
									field?.value === optionId.toString()
										? "1px solid #BE0303"
										: "",
							}}
						/>
					);
				})}
			</RadioGroup>
			{hasError && <small className="text-danger">{errorMessage}</small>}
		</div>
	);
};

export default RadioButtons;
